import { ProductionFulfillmentApi, useAPIQuery } from "melco-shared-logic";

const queryKeyForInputFormat = (inputFormatId: string) => {
  return ["inputFormat", inputFormatId];
};

export const useInputFormat = (inputFormatId: string | undefined) => {
  return useAPIQuery(
    ProductionFulfillmentApi,
    queryKeyForInputFormat(inputFormatId ?? ""),
    async (api) => {
      if (inputFormatId == null) {
        return;
      }

      return api.productionFulfillmentFormatsGetFormat({ id: inputFormatId });
    }
  );
};
